const onboarding = {
  // A
  are_you_sure_to_delete: 'Are you sure to delete <bold>{{name}}</bold> department?',
  action: 'Action',
  add: 'Add',
  add_all: 'Add All',
  adding_new_departments_helper: 'Adding new departments',
  area: 'Area',
  activate_offline: 'select offline',
  ajeer_onboarding: 'Ajeer',
  address: 'Address',
  adjust_your_logo: 'Adjust your logo',
  add_iban: 'Add IBAN',
  edit_iban: 'Edit IBAN',
  add_new_allowance: 'Add new Allowance',
  add_new_contract_type: 'Add new contract type',
  add_business_unit: 'Add Business Unit',
  add_new_custom_leave_onboarding: 'Add new custom leave',
  add_new_work_location: ' Add New Work Location',
  add_all_mentioned_above: 'Add All Mentioned Above',
  add_business_units_savola_groups: 'Add Business Units to {{groups_name}}',
  Add_departments_to_Savola_Groups: 'Add departments to {{groups_name}}',
  a_unique_name_linked_to_our_main_domain_jisr_description:
    'A unique name linked to our main domain, {{domain}}, that your employees will use to login to {{app_name}}',
  an_organisation_desc:
    'An organisation is the top level body that you use to run one or multiple businesses under.',
  annual_leave_entitlement_onboarding: 'Annual Leave Entitlement',
  annual_leave_auto_upgrade: 'Annual Leave Auto-upgrade ',
  annual_leave_auto_upgrade_description:
    'When an employee completes 5 years in your organization, the annual leave balance will automatically increase to the defined value. Unless the employee already has more than it.',
  account_setup: 'Account Setup',
  attendance_setup: 'Attendance Setup',
  add_holidays_leave: 'Add Holidays leave',
  annual_leave_policies: 'Annual Leave Policies',
  annual_leave_onboarding: 'Annual Leave',
  annual_leave_settings: 'Annual Leave Calculation',
  annual_leave_settings_description:
    "By defining annual leave calculation type (business or calendar), employees' balance deduction method will differ. You can choose only one method to be used for annual leave calculation.",
  annual_leave_entitlement_onboarding_description:
    ' By setting the annual leave balances, you will be able to select the annual balance for each employee.',
  accumulative_balance: 'Accumulative Balance',
  accumulative_balance_description:
    'Balance will be increased daily for each employee based on their annual entitlement.',
  accumulative_balance_description_tip:
    'Tip: if the annual entitlement is 30, and the employee spent 3 months with your organization, the available balance will be 7.5 days.',
  all_basic_information_for_your_organization_is_saved:
    'All basic information for your organization is saved',
  allowances_onboarding: 'Allowances',
  allowances_desc:
    'You can customize what allowances to be added to employees basic salary every month',
  allowances_list: 'Allowances',
  allowance_name_en: ' Allowance name (English)',
  type_allowance_name: 'Type allowance name',
  allowance_name_ar: ' Allowance name (Arabic)',
  authorize_payment_admins: 'Authorize Payment Admins',
  authorized_person_desc: 'The authorized employees can process the payroll payment with Mudad.',
  admin_users: 'Admin users',
  add_admins_onb: 'Add Admins',
  Make_sure_that_have_admin:
    'Make sure that you have added valid email addresses to the employees you desire to add as admins in this step so you can view them here',
  admin_users_desc:
    'Select users to give admin permissions to your {{app_name}} account, this will give them full access to all employees data and system settings.',
  add_only_the_admins:
    "Add only the admins that will be managing your {{app_name}} account within your organization, The rest of the employees' invitations will come in a later step",
  new_leave: 'New Leave',
  add_new_location: 'Add New Location',
  // B
  bank_account_desc: 'The selected bank account will be used to process the payroll payment',
  based_on_your_industry_type:
    'Based on your industry type, our system is suggesting you some relevant job titles. You can add these, or you can define custom job titles.',
  browse_computer: 'browse computer',
  add_business_units: 'Add business units',
  business_units_discription: 'Business Units  Discription',
  based_on_your_industry_desc:
    'Based on your industry type, our system is suggesting you some relevant job titles. You can add these, or you can define custom job titles.',
  benefits_in_kind:
    'Benefits in kind (also called fringe benefits or perks) include various types of non-wage compensation provided to employees in addition to their normal wages or salaries.',
  brand_name_en: 'Brand Name (English)',
  brand_name_ar: 'Brand Name (Arabic)',
  onboarding_brand_name: 'Brand Name',
  bulk_update: 'Bulk Update',
  business_days: 'Business Days',
  business_days_discription:
    'Only count working days in leaves. Example: When an employee applies for a 7 days leave (from 1st Oct to 7th Oct, it will be counted as 5 days leave because it contains 2 weekend days).',
  add_custom_leave: 'Add Custom leave',
  // C
  cancel: 'Cancel',
  carry_forward_balance: 'Carry forward balance',
  city: 'City',
  country: 'Country',
  continue: 'Continue',
  cr_number: 'CR No.',
  check_Availability: 'Check Availability',
  checking_subdomain_availability: 'Checking subdomain availability',
  copmany_logo_desc:
    "Your copmany logo will always appear on the top of your {{app_name}} system interface, as well as the mobile app. Make sure it's in a JEPG or PNG format.Please make sure the size of the logo does not exceed 2MB",
  org_name: 'Org Name',
  commercial_registration_details:
    'Kindly, Enter the commercial registration details and information so that it can be easily synchronized and saved in the {{app_name}} system. Just make sure that you have only added CRs connected to your employees, so if you have any CR that isn’t connected to your employees then you don’t need to add it here',
  completed_msg:
    'Congratulation, you already completed the first stage of {{app_name}} Onboarding.',
  calendar: 'Calendar',
  carry_all_forward: 'Carry Forward All Balance',
  carry_all_forward_description:
    'All remaining balance will be transferred at the end of the year to the new year’s balance.',
  calendar_days: 'Calendar Days',
  calendar_days_description:
    'Count every day as leave regardless of weekend or not. (except for public holidays)',
  customizing_leaves: 'Customizing leaves ',
  customizing_leaves_description:
    "You can add leave types based on your organization’s need, you can define the name that will appear to employees, and the days per year. You might also turn these on/off if it's seasonal leave.",
  cutoff_day: 'Cut-off Day',
  configured_by_bank_file: 'Offline method (using Bank file)',
  cutoff_day_desc:
    'The cut-off date is the day you start prepare and group all transactions such as attendance records, loans, leaves, and so on in order to include them in your payroll The transactions received after the cut-off date (From 26 that shown in the calendar ) will usually not be reflected until the following month. So attendance records which belong to the period after the cut-off will be handled in next month payroll, same thing when there is an employee joined your team after the cut off his salary will be received within next month payroll',
  congratulations_onboarding: 'Congratulations !',
  check_email: 'Check email',
  create_password: 'Create password',
  confirm_title: 'Have you added yourself?',
  confirm_msg:
    'Please note that you’ll need to add yourself as an Admin to be able to receive an email to reset your password and get started!',
  confirm_but: 'I added myself',
  confirm_cancel: 'Back to editing',
  company_name_en: 'Company Name (English)',
  company_name_ar: 'Company Name (Arabic)',
  commercial_registration: 'Add your Commercial Registration',
  customized_settings: 'Customized Settings',
  customized_settings_title: 'Customize your leaves and payroll settings yourself',
  org_account_link: 'Org Account Link',
  click_here_onboard: '[Click Here]',
  check_your_inbox: 'Check your inbox!',
  check_your_inbox_description:
    'We have sent you a  temporary 4-digits code at {{email}}. Please enter this code to verify your account',
  // D
  deleting_the_adminstration_department:
    'Deleting the <bold>{{name}}</bold> department will also delete its {{count}} sub-departments:',
  des_for_name: 'Follow the next steps to activate your account',
  des_login_to_jisr: 'Use your new credentials to join and enjoy {{app_name}} Services',
  des_create_password: 'Click on the link to create your password',
  des_check_email: 'We have sent you a link on',
  download_uploaded_data: 'Download Uploaded Data',
  download_faulty_records: 'Download errors file',
  delete: 'Delete',
  disabled: 'Disabled',
  done_finish: 'Done',
  didnt_receive_otp: "Didn't receive OTP?",
  do_you_have_one_multi: 'Do you have one CR or Multi?',
  define_custome_job_title: 'Define Custome Job Title',
  define_job_titles_description: 'Define job titles for {{groups_name}}',
  define_assets_description: 'Define all the assets types you would like to add to {{groups_name}}',
  do_you_have_subsidiaries_description: 'Do you have subsidiaries under Savola Groups?',
  download_sample_employee_data_file: 'Download Sample Employee Data File',
  define_a_new_employment_type: 'Define a new employment type',
  define_business_units_desc:
    'Please, Define  Business Units that are in your organization. So, you can easily assign employees to the specific Units.',
  department_division_desc:
    'Here you can add the parent departments and each department should have at least 1 child department. You can only assign employees to child departments and they will be assigned automatically to the parent department so ',
  define_various_desc:
    'You can define various types of employment to be able to arrange and manage the employees in the best possible way',
  Do_you_run_one: 'Do you run one Business or more? ',
  download_leave_etails_sheet: 'Download Annual Leave sheet',
  download_salaries_details_sheet: 'Download Salaries Details Sheet',
  drag_and_drop_file_or: 'Drag and drop file or,',
  drag_and_drop_file_or_browse_computer: 'Drag and drop file or browse computer',
  drag_and_drop_files_or_browse_computer: 'Drag and drop files or browse computer',
  dayse_per_year: 'Days per year',
  default_settings: 'Default Settings [Labor Law Compliant]',
  des_customized: 'If you choose this, you will configure all the settings by yourself',
  drag_and_drop: 'Drag & drop logo or click to browse',
  delete_confirmation: 'Delete Confirmation',
  didnt_receive_the_code: 'Didn’t receive the code?',
  // E
  edit_business_unit: 'Edit Business Unit',
  admins_invitation: 'Admins Invitation',
  emp_id: 'Emp ID',
  edit: 'Edit',
  enter: 'ENTER',
  enter_cr_details: 'Enter CR Details ',
  enter_iban: 'Enter IBAN',
  enter_mol_details: 'Enter MOL Details ',
  enter_gosi_number: ' Enter GOSI Number ',
  enter_gosi_details: ' Enter GOSI details ',
  enter_leave_name: 'Enter Leave name',
  enter_leave_name_ar: 'Enter Leave name AR',
  enter_dayse_per_year: 'Enter Dayse per year',
  enter_the_main_headquarter_desc:
    'Enter the main headquarter address for your organization. You can add the addresses for other locations later',
  employment_type_discription: 'Employment type Discription',
  email: 'Email',
  employee_onboarding: 'Employee',
  employee_payment_details: 'Employee Payment Details',
  employee_payment_details_desc:
    'After adding the allowances of your company, Now define the payment info of your employees.',
  employees_data: 'Employees data',
  enable_employees_to_use_jisr_by_inviting_them:
    'Enable employees to use {{app_name}} by inviting them',
  exit: 'Exit',
  // F
  faulty_records_new_records_added:
    '{{faulty}} Records have errors, {{added}} New Records are added',
  file_processed: 'File Processed',
  food_beverages: 'Food & Beverages',
  finance_real_estate: 'Finance & Real Estate',
  for_outsource_employees: 'For outsource employees',
  follow_the_labor_law_holidays: 'Follow the labor law holidays',
  full_balance: 'Full Balance',
  full_balance_description:
    'The expected year end balance will be available to the employee from the first day.',
  full_balance_description_tip:
    'Tip: This action might affect entitlement if an employee used the balance and ended the contract before completing the year.',
  faster_setup: 'Faster Setup',
  // G
  great_your_organisation_is_set_up: 'Great, your organisation is set-up',
  gosi_files: 'GOSI Files',
  gosi_files_status: 'GOSI files status',
  gosi_numberr: 'GOSI Number',
  // H
  hello: 'Hello',
  help_center: 'Help Center',
  help_videos: 'Help Videos',
  hospitality_hotels: 'Hospitality & Hotels',
  // I
  iban_onboarding: 'IBAN',
  industry_name_en: 'Industry Name En',
  industry_name_ar: 'Industry Name AR',
  import_employee_data: 'Import Employee Data',
  industry: 'Industry',
  invite_employees: 'Invite Employees',
  invite_admins: 'Invite Admins',
  invite_employees_description: `By enabling this option, whenever an employee returns from a leave, a confirmation request will be required from the employee.
  If you use {{app_name}} Attendance the request will be auto-generated once the employee clocks-in. Then it will be the manager's job to confirm the employee's return. Otherwise the employee will be recorded Absent.
  If you disable this option, employee’s attendance will be treated as usual after returning from leave.`,
  invite_admin_users: 'Invite Admins',
  invite_all: 'Invite All Admins',
  invited: 'Invited',
  invited_emp: 'Invitation Sent',
  // J
  // K
  kindl_define_your_industry: 'Kindl, define your industry',
  kindly_ensure_to_add_the_email_description:
    'Kindly, ensure to add the email for employees that you would like to invite to log in to the next step',
  // L
  labor_law_leaves_and_public_holidays: 'Labor Law Leaves',
  let_us_know_more_about_your_organization: "let's build your organizational structure",
  Lets_import_your_employee_data: 'Let’s import your employee data',
  logo: 'Logo',
  leave_config_done: 'Leave preferences are all set',
  limited_carry_forward: 'Limited Carry Forward',
  limited_carry_forward_description:
    'Set a maximum number of days that can be transferred to the new year’s balance.',
  leaves_setup: 'Leaves Setup',
  labor_law_leaves: 'Labor Law Leaves',
  labor_law_leaves_description:
    'By default, Saudi labor law leaves are enabled to ensure your organization is complied with labor law. However, you can set and adjust leaves depending on your organization’s policy.',
  leave_name_onboardin: 'Leave name',
  leave_name_ar_onboardin: 'Leave name AR',
  login_to_jisr: 'Login to {{app_name}}',
  leaves_and_payroll_configurations: 'Leaves & Payroll Configurations',
  launch_account: 'Launch Account',
  // M
  move_the_adminstration_department:
    'Moving the <bold>{{name}}</bold> department will also move its {{count}} sub-departments:',
  multi_crs: 'Multi CRs',
  mudad_desc: 'Automated and hassel free It’s Linked with the Banks and WPS',
  mudad_setup: 'Mudad Setup',
  mol_prefix: 'MOL prefix',
  mol_number: 'MOL Number ',
  mol_prefix_1_28: 'MOL prefix 1 - 38',
  media_sdvertisement: 'Media & Advertisement',
  mol_files: 'MOL Files',
  muqeem_files: 'Muqeem Files',
  make_this_main_work_location_for: 'Make this main work location for {{name}}',
  minimum_value: 'Minimum value',
  more_customized: 'More Customized',
  mudad_cr_number: 'CR-{{number}}',
  mudad_subscription: 'Mudad Subscription',
  // N
  name_in_english_onboarding: 'Name in English',
  no: 'NO',
  name_in_english: 'Name in English',
  name_in_arabic: 'Name in Arabic',
  note_each_parent_department_should_description:
    'make sure that you have added at least 1 child department in each parent department',
  note: 'Note',
  No_confirmation_is_needed: 'Do not require return confirmation from annual leave',
  No_confirmation_is_needed_description:
    'No confirmation is required, the employee return date will be the first working day after the annual leave.',
  next_onboardin: 'Next',
  number_of_employees_use_bank: 'Number of employees use Bank',
  number_of_employees_use_cash: 'Number of employees use Cash',
  number_of_employees_use_cheque: 'Number of employees use Cheque',
  number_of_employees_use_international_transfer: 'Number of employees use International Transfer',
  next_month_date: 'Next Month ({{date}})',
  // O
  offline_processing_desc:
    'Process payments manually Download the bank file and upload it to your bank.',
  offline_setup: 'Offline method (using Bank file)',
  one_cr: 'One CR',
  organization_details_onboarding: 'Organization details',
  others: 'Others',
  onboarding_mudad_otp_message:
    'We’ve sent an OTP to <b>{{name}}</b> mobile number ending with <b>{{number}}</b>. Please contact the and get the OTP to verify the user.',
  onboarding_steps: 'Onboarding Steps',
  organization_name_en: 'Organization Name in En',
  organization_name_ar: 'Organization Name AR (Optional)',
  organization: 'Organization',
  organization_type: 'Organization type',
  opening_balance: 'Opening Balance',
  organization_info_onboarding: 'Organization Info',
  owner_verification_step: 'Owner/Authorizer Verification',
  owner_verification_desc:
    'Please put the Identification Number for the the owner or the authorizer for the establishment within GOSI',
  organization_logo: 'Organization Logo',
  org_details_and_industry: 'Legal Structure',
  org_structure_and_logo: 'Organization Details',
  onboarding_subdomain: 'What subdomain you would like to use for your account?',
  onboarding_invalid_or_expired_token: 'Invalid or Expired token, Please connect with your admin',
  // P
  primary_work_location: 'Primary Work Location',
  press: 'press',
  press_ENTER: 'press ENTER',
  Please_upload_mol_muqeem_and_gosl_files_for_your_crs:
    'Please update MOL and Muqeem files for your CRs.',
  please_import_the_employee_data_file_after_you_fill_it:
    'Please import the employee data file after you fill it',
  pay_day: 'Pay Day',
  pay_schedules: 'Pay Schedules',
  pay_schedules_desc:
    'Payroll month & cut-off will determine how you will be able to process your payroll every month',
  payment_file: 'Payment file',
  payment_methods_desc:
    'Selecting your payment method will affect the way we handle payrolls, using Mudad will automate all your payroll and link with banks and WPS. While offline will process the payments manually.',
  payroll_bank: 'Payroll Bank',
  payroll_bank_desc:
    "The bank account for each CR will be used to transfer employees' salaries. Please add a bank account for the CR you had in your company.",
  payroll_month_desc:
    'Do you want to start using {{app_name}} Payroll this month or the next month?',
  payroll_payment_file: 'Payroll payment file',
  payroll_payment_file_desc:
    'Upload the last payroll bank file, so {{app_name}} can extract all payment information for your employees.',
  payroll_setup: 'Payroll Setup',
  payroll_setup_desc:
    'Upload employees salary packages, select the cut-off day, and choose your payment method',
  public_holidays: 'Public Holidays',
  payroll_preferences_are_all_set: 'Payroll preferences are all set',
  public_holidays_description:
    'Unlike the previous sections, these are holidays for all employees in your organization.',
  public_holidays_tip:
    'Tip: Labor law requires a minimum of holidays to each employee, if the organization needs to work on holiday, it should offer the employee a substitute for his entitled holiday.',
  preferred_settings: 'What’s your preferred settings?',

  // Q
  // R
  remove: 'Remove',
  retail: 'Retail',
  review: 'Review',
  resend_code: 'Resend code',
  review_employees_data: 'Review Employees Salaries',
  review_employees_data_desc:
    'This is how the employees’ salaries will be on {{app_name}}, you can review and do changes if needed.',
  review_employees_payment: 'Salary receiving method',
  review_employees_payment_desc:
    'This is how your employees will receive their salaries, you can review the data and edit it .',
  reviewing_employee_data: 'Reviewing employee data',
  review_page: 'Review Leave Details',
  review_page_description:
    'This is how the employees’ data will be on {{app_name}}, you can review the data before uploading it on {{app_name}}.',
  remaining_balance_onboarding: 'Remaining Balance',
  remaining_balance_settings: 'Remaining Balance',
  remaining_balance_settings_description:
    'You can set how the remaining balance will be treated If an employee ended the year without using all annual leave balance, using the following options',
  remaining_balance_settings_description_tip:
    'Tip: Employees should have their leaves during the year, if the company didn’t allow them to go for a leave, it might be illegal to reset the balance.',
  return_confirmation: 'Return confirmation',
  return_confirmation_description:
    'You can use return confirmation to ensure the employee has returned from the annual leave. In all cases, {{app_name}} will record attendance for all employees',
  return_confirmation_description_tip:
    "If you use {{app_name}} Attendance the request will be auto-generated once the employee clocks-in. Then it will be the manager's job to confirm the employee's return. Otherwise the employee will be recorded Absent.",
  resend: 'Resend',
  reset_balance: 'Reset Balance',
  reset_balance_description:
    'Transferring balance is not allowed, employee balance will reset each year.',
  require_Return_Confirmation_after_leave: 'Require return confirmation from annual leave',
  require_Return_Confirmation_after_leave_description:
    "All employees are required to confirm their return through {{app_name}}. If the employee had advanced vacation salary and didn't confirm their return, they will not be included in the payroll until the return is confirmed.",
  // S
  set_type_to_all:
    'Set type to All <icon /> Set jobs to All <icon /> Set nationality to All <icon /> Click “Download Data”. : need trans',
  submit_merge: 'Submit & Merge',
  subdomain_name: 'Subdomain',
  search_employees_by_id_or_name: 'Search employees by ID or name',
  save: 'Save',
  salary_setup: 'Employees Salary',
  salaries_packages: 'Salaries Packages',
  salaries_packages_desc:
    'After adding the allowances of your company, now define the salary packages of your employees.',
  salary_card_no: 'Salary Card No',
  skip: 'Skip',
  software: 'Software',
  setup_your_main_organization: 'Setup Your Main Organization',
  something_went_wrong_description: 'Something went wrong. Please try again!',
  subdomain: 'Subdomain',
  summary_review: 'Summary Review',
  summary_review_desc:
    'In this step, just make sure all of the data is correct. You can always go back and edit any piece of information.',
  select_bank: 'Select Bank',
  select_your_preffered_language_it_will_be_used_throughout_this_wizard:
    'Select your preffered language. It will be used throughout this wizard.',
  language_selection: 'Language Selection',
  setting_up_your_organization: 'Setting up your organization',
  set_annual_leave_policy:
    'Set annual leave policy, labor law leaves, employees annual leave balances.',
  select_the_field_desc:
    "Select the field or the industry in which your organization opeartes. If you can't find yours, choose other.",
  select_holidays: 'Select Holidays',
  starting_balance: 'Starting Balance',
  starting_balance_description:
    'You can select how the starting balance for annual leave will be to your employees.',
  start: 'Start',
  start_command: 'Start',
  select_payment_method: 'Select Payment Method',
  saudi_labor_law: 'Leaves & Payroll settings will follow the Saudi labor law',
  saudi_labor_title: 'Saudi Labor Law will be applied!',
  saudi_labor_des:
    'All settings will be set to follow the Saudi labor law, but we will also keep any addition you made in settings.',
  review_search_placeholder: 'Search by Employee ID, Name or Employment Type',
  check_slug: 'This slug is already in use! Please pick another slug',
  select_users:
    'Select users to give admin permissions to your {{app_name}} account, this will give them full access to all employees data and system settings.',
  // T
  this_configuration_desc:
    'This configuration sets up on which the deduction of absenteeism the vacation salary can depend on: Full package, Basic salary, or Basic + selected allowances',
  technology: 'Technology ',
  the_cutoff_date: 'The Cut-off Date',
  the_selected_bank_for_the_payroll: 'The selected bank for the payroll',
  select_cutoff_date: 'Select Cut-off date',
  cutoff_date: 'Cut-off Date',
  cutoff_date_desc:
    'By defining the cut-off date {{app_name}} will prepare and group all transactions till the selected date to include them in your payroll till such as attendance record',
  this_subdomain_is_taken: 'This subdomain is taken',
  types: 'Types',
  this_month_date: 'This Month ({{date}})',
  // U
  upload_Savola_Groups_Logo: 'Upload {{groups_name}} Logo',
  upload_govt_files: 'Upload Govt. Files',
  upload_employee_data: 'Upload Employee Data',
  update_bulk_employees_salaries: 'Bulk update for employees Salaries',
  usually_has_the_following_job_titles: '{{name}}, usually has the following job titles.',
  usually_has_the_following_job_assets: 'Recommendations for the most common assets types',
  up_to_which_date: 'Up to Which date',
  user_role: 'User Role',
  use_the_labor_low_leaves: 'Use the labor Low leaves',
  update_custom_leave_onboarding: 'Update custom leave',
  update_add_holidays_leave: 'Upload Holidays leave',
  upload_annual_leave_files: 'Upload Annual Leave Files',
  upload_annual_leave_files_discription: `To upload your current employees’ annual leave data on {{appName}}:
  <br />1- Download the Leave details sheet
  <br />2- Fill out the sheet with employees’ details
  <br />3- Upload the sheet`,
  upload_employees_salaries_data_desc: `To upload your employees’ salaries data on {{appName}}:
  <br />1- Download Salaries Details Sheet
  <br />2- Fill out the sheet with employees’ details
  <br />3- Upload the sheet`,
  // V
  verify_employees_desc:
    'Select the employees who are authorized to process payroll payment through your bank.',
  verify_otp: 'Verify OTP',
  verify_payment_admins: 'Verify Payment Admins',
  verify_payment_admins_step: 'Verify Payment Admins',
  view_more: 'View more',
  verify_now: 'Verify now',
  view_the_applied_settings: 'To view the applied settings on your organization',
  // W
  which_medical_insurance: 'Which Medical Insurance company are you working with?',
  which_accounting_system: 'Which Accounting System tool are you using?',
  which_pos_system: 'Which POS system are you using in your organization?',
  what_is_the_other_company: 'What other company do you use?',
  work_location: 'Work Location',
  whats_your_preferred_language: "What's your preferred language? ",
  what_industries_Savola_description: "What's {{name}} industry?",
  work_locations_for_savola_groups: 'Work locations for Savola Groups',
  whats_the_name_of_your_organization: 'What’s the name of your organization?',
  what_subdomain_would_description:
    'What subdomain for {{groups_name}} would you like to have as {{app_name}} account?',
  what_employment_types_you_have: 'What Contract type you have?',
  we_ve_created_a_sample_employee_data_description:
    'We’ve created a sample Employee Data Sheet based on the selection you’ve made thus far. Download, and upload it back after editing as per your needs.',
  whats_the_name_of_outsource_provider_description:
    'What’s the name of outsource provider for your Ajeer employees?',
  welcome_dear_name_to_jisr: 'Welcome Dear {{name}} to {{app_name}}',
  wizard_language: 'Wizard Language',
  will_do_it_later: 'I’ll do it later',
  would_you_like_to_delete_description: 'Would you like to delete the employee you selected?',
  would_you_like_to_delete_employees_description:
    'Would you like to delete the employees you selected?',
  // X
  // Y
  yes: 'Yes',
  youre_good_to_go: "You're good to go",
  You_ve_successfully_uploaded_the_employee_data_description:
    'You’ve successfully uploaded the employee data. Let’s review it now.',
  // Z
}

export default onboarding
